import {Action, combineReducers, createStore, applyMiddleware, compose} from '@reduxjs/toolkit'
import thunk, {ThunkMiddleware} from 'redux-thunk'
import {DeviceSelectorReducer} from "./DeviceSelectorReducer";

const deviceSelectorRootReducer = combineReducers({
  DeviceSelector: DeviceSelectorReducer,
});

export type DeviceSelectorRootState = ReturnType<typeof deviceSelectorRootReducer>


export interface DispatchAction extends Action {
  payload: any;
}

const middleware = thunk as ThunkMiddleware<DeviceSelectorRootState, DispatchAction>;

export const deviceSelectorStore =  createStore(
  deviceSelectorRootReducer,
  compose(applyMiddleware(middleware))
);
